import { Target, TrendingUp, Brain, Zap, ShieldCheck } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import ProductCard from "../../components/marketing/ProductCard";

export default function ProductsListingPage() {
  return (
    <MarketingLayout>
      <section className="relative overflow-hidden">
        <div aria-hidden className="absolute inset-0 -z-10">
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-blue-100 dark:bg-blue-950/40 blur-3xl opacity-40" />
        </div>
        <div className="max-w-7xl mx-auto px-5 md:px-8 pt-20 pb-16 md:pt-28 md:pb-20 text-center">
          <div className="font-ibm-plex text-[10px] tracking-widest uppercase text-blue-600 dark:text-blue-400 font-bold mb-4">The Ecosystem</div>
          <h1 className="font-outfit text-5xl md:text-6xl font-black text-slate-900 dark:text-white leading-[1.05]">
            Intelligence Platforms
          </h1>
          <p className="mt-5 max-w-2xl mx-auto font-ibm-plex text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
            Every product in the SYNQ ecosystem answers the same question — <span className="text-slate-900 dark:text-white font-semibold">what should we do next?</span>
          </p>
        </div>
      </section>

      <section className="border-t border-slate-200 dark:border-slate-800">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-20">
          <div className="font-ibm-plex text-[10px] tracking-widest uppercase text-slate-500 font-bold mb-6">Live Platforms</div>
          <div className="grid md:grid-cols-2 gap-5">
            <ProductCard
              name="SYNQ Projects"
              subtitle="Project Intelligence Platform"
              description="Predict project health, delivery confidence, execution quality and organizational capability across every project."
              to="/products/projects"
              accentClass="bg-blue-200 dark:bg-blue-900/50"
              badge="Live"
              icon={<Target className="w-5 h-5" />}
            />
            <ProductCard
              name="SYNQ Evolve"
              subtitle="Organizational Intelligence Platform"
              description="Understand leadership, team dynamics, culture and organizational intelligence — continuous improvement, guided by AI."
              to="/products/evolve"
              accentClass="bg-emerald-200 dark:bg-emerald-900/50"
              badge="Live"
              icon={<TrendingUp className="w-5 h-5" />}
            />
          </div>

          <div className="font-ibm-plex text-[10px] tracking-widest uppercase text-slate-500 font-bold mt-16 mb-6">Coming Soon</div>
          <div className="grid md:grid-cols-3 gap-5">
            <ProductCard
              name="SYNQ AI"
              subtitle="Applied AI Intelligence"
              description="Bespoke, domain-aware AI advisors integrated into your organization's workflows."
              to="#" accentClass="bg-purple-200 dark:bg-purple-900/50"
              badge="Coming Soon" icon={<Brain className="w-5 h-5" />}
            />
            <ProductCard
              name="SYNQ Strategy"
              subtitle="Strategic Intelligence"
              description="Turn strategic intent into measurable, tracked outcomes with real-time strategic sensing."
              to="#" accentClass="bg-amber-200 dark:bg-amber-900/50"
              badge="Coming Soon" icon={<Zap className="w-5 h-5" />}
            />
            <ProductCard
              name="SYNQ Risk"
              subtitle="Risk Intelligence"
              description="Detect and pre-empt organizational, operational and delivery risk — before it surfaces."
              to="#" accentClass="bg-rose-200 dark:bg-rose-900/50"
              badge="Coming Soon" icon={<ShieldCheck className="w-5 h-5" />}
            />
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
